import { render, staticRenderFns } from "./SubItems.vue?vue&type=template&id=375ca49a&scoped=true"
import script from "./SubItems.vue?vue&type=script&lang=js"
export * from "./SubItems.vue?vue&type=script&lang=js"
import style0 from "./SubItems.vue?vue&type=style&index=0&id=375ca49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375ca49a",
  null
  
)

export default component.exports